// TODO: Delete and replace or add type checking
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

type sizesType = {
    [key: string]: [number, number];
};

export const sizes = {
    small: [0, 599],
    medium: [600, 899],
    normal: [900, 1299],
    large: [1300, 5000],
} as sizesType;

function isViewportInRange(min: number, max: number) {
    return window.innerWidth >= min && window.innerWidth <= max;
}

export function isSmallViewport() {
    return isViewportInRange(sizes['small'][0], sizes['small'][1]);
}

export function isMediumViewport() {
    return isViewportInRange(sizes['medium'][0], sizes['medium'][1]);
}

export function isNormalViewport() {
    return isViewportInRange(sizes['normal'][0], sizes['normal'][1]);
}

export function isLargeViewport() {
    return isViewportInRange(sizes['large'][0], sizes['large'][1]);
}
